"use client";

import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { ChevronRight } from "lucide-react";
import React from "react";

import { cn } from "../../helpers";
import * as styles from "./radio-card.styled";

interface RadioCardProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  checked: boolean;
  disabled?: boolean;
  className?: string;
  variant?: "default" | "compact";
}

export const RadioCardGroup = React.forwardRef<
  React.ComponentRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn(styles.radioGroup, className)}
      {...props}
      ref={ref}
    />
  );
});
RadioCardGroup.displayName = "RadioCardGroup";

export const RadioCard = React.forwardRef<
  React.ComponentRef<typeof RadioGroupPrimitive.Item>,
  RadioCardProps & { onClick?: () => void }
>(
  (
    {
      icon,
      label,
      value,
      checked,
      disabled,
      className,
      variant = "default",
      ...props
    },
    ref,
  ) => {
    const compact = variant === "compact";
    return (
      <label
        className={cn(
          styles.radioCardVariants({ checked, disabled }),
          compact && "min-h-[56px]",
          className,
        )}
        htmlFor={value}
      >
        <div className={styles.root}>
          <div className={cn(styles.wrapper, compact && "gap-3")}>
            {icon}
            <span className={styles.label}>{label}</span>
            <RadioGroupPrimitive.Item
              className="sr-only"
              value={value}
              id={value}
              disabled={disabled}
              ref={ref}
              {...props}
            />
          </div>
          <ChevronRight />
        </div>
      </label>
    );
  },
);
RadioCard.displayName = "RadioCard";
